import { NgModule } from '@angular/core';

import { DragDropModule } from '@angular/cdk/drag-drop';

import { FormsModule } from '@angular/forms';
import { PieChartModule } from '@swimlane/ngx-charts';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import { SharedManagerAssessmentsModule } from '../assessments-manager/shared/shared-manager-assessments.module';
import { CardCourseComponent } from './components/card-course/card-course.component';
import { CollectionStudioComponent } from './components/collection-studio/collection-studio.component';
import { ModalCertificateFormComponent } from './components/modal-certificate-form/modal-certificate-form.component';
import { ModalCertificatePreviewComponent } from './components/modal-certificate-preview/modal-certificate-preview.component';
import { ModalCertificateComponent } from './components/modal-certificate/modal-certificate.component';
import { ModalCoursesComponent } from './components/modal-courses/modal-courses.component';
import { ModalDisplayChartComponent } from './components/modal-display-chart/modal-display-chart.component';
import { ModalDocPreviewComponent } from './components/modal-doc-preview/modal-doc-preview.component';

import { SHARED_MODULES } from '@app/shared';
import { BadgeComponent } from '@app/shared/modules/badge/badge.component';
import { FileViewerComponent } from '@app/shared/modules/file-viewer/file-viewer.component';
import { TextEditorComponent } from '@app/shared/modules/text-editor/text-editor.component';
import { UploadFileComponent } from '@app/shared/modules/upload-file/upload-file.component';
import { UserPhotoComponent } from '@app/shared/modules/user-photo/user-photo.component';
import { ModalDuplicateCoursesComponent } from './components/modal-duplicate-courses/modal-duplicate-courses.component';
import { ModalEventsComponent } from './components/modal-events/modal-events.component';
import { ModalLearningFormElementComponent } from './components/modal-learning-form-element/modal-learning-form-element.component';
import { ModalProductsVoucherComponent } from './components/modal-products-voucher/modal-products-voucher.component';
import { ModalReportComponent } from './components/modal-report/modal-report.component';
import { ModalSubdivisionsComponent } from './components/modal-subdivisions/modal-subdivisions.component';
import { ModalVoucherComponent } from './components/modal-voucher/modal-voucher.component';
import { OptionTreeSubdivisionComponent } from './components/option-tree-subdivision/option-tree-subdivision.component';
import { PopoverReportFilterComponent } from './components/popover-report-filter/popover-report-filter.component';
import { PopoverReportComponent } from './components/popover-report/popover-report.component';
import { PopoverSubdivisionsComponent } from './components/popover-subdivisions/popover-subdivisions.component';
import { PreviewCertificadoComponent } from './components/preview-certificado/preview-certificado.component';
import { SelectCategoryComponent } from './components/select-category/select-category.component';
import { SidenavLearningAnnexComponent } from './components/sidenav-learning-annex/sidenav-learning-annex.component';
import { SidenavLearningFormTrailsComponent } from './components/sidenav-learning-form-trails/sidenav-learning-form-trails.component';
import { SidenavLearningStudioCategoryComponent } from './components/sidenav-learning-studio-category/sidenav-learning-studio-category.component';
import { SidenavLearningStudioCollectionComponent } from './components/sidenav-learning-studio-collection/sidenav-learning-studio-collection.component';
import { SidenavLearningStudioShowcaseComponent } from './components/sidenav-learning-studio-showcase/sidenav-learning-studio-showcase.component';
import { SidenavLearningStudioComponent } from './components/sidenav-learning-studio/sidenav-learning-studio.component';
import { SidenavLearningTrailsComponent } from './components/sidenav-learning-trails/sidenav-learning-trails.component';
import { SidenavLearningUnitComponent } from './components/sidenav-learning-unit/sidenav-learning-unit.component';
import { AudioCardComponent } from './components/trail-elements/audio-card/audio-card.component';
import { FlipCardComponent } from './components/trail-elements/flip-card/flip-card.component';
import { ImageCardComponent } from './components/trail-elements/image-card/image-card.component';
import { LinkCardComponent } from './components/trail-elements/link-card/link-card.component';
import { TestCardComponent } from './components/trail-elements/test-card/test-card.component';
import { VideoCardComponent } from './components/trail-elements/video-card/video-card.component';
import { TreeSubdivisionComponent } from './components/tree-subdivision/tree-subdivision.component';
import { TreeTrailComponent } from './components/tree-trail/tree-trail.component';
import { UploadAudioElementComponent } from './components/upload-audio-element/upload-audio-element.component';
import { UploadFlipElementComponent } from './components/upload-flip-element/upload-flip-element.component';
import { UploadImageElementComponent } from './components/upload-image-element/upload-image-element.component';
import { UploadLinkElementComponent } from './components/upload-link-element/upload-link-element.component';
import { UploadVideoElementComponent } from './components/upload-video-element/upload-video-element.component';
import { LearningTrailsRoutingModule } from './learning-trails-routing.module';
import { CourseDeshboardComponent } from './pages/course-dashboard/course-dashboard.component';
import { CoursesComponent } from './pages/courses/courses.component';
import { ReportComponent } from './pages/report/report.component';
import { ShowcaseComponent } from './pages/showcase/showcase.component';
import { StudioComponent } from './pages/studio/studio.component';
import { ElementComponent } from './pages/trail/trail.component';
import { UnitComponent } from './pages/unit/unit.component';
import { FilterCoursePipe } from './pipes';

@NgModule({
  declarations: [
    CoursesComponent,
    ShowcaseComponent,
    UnitComponent,
    ElementComponent,
    StudioComponent,
    SelectCategoryComponent,
    SidenavLearningTrailsComponent,
    SidenavLearningStudioComponent,
    SidenavLearningFormTrailsComponent,
    SidenavLearningUnitComponent,
    SidenavLearningStudioCategoryComponent,
    SidenavLearningStudioCollectionComponent,
    SidenavLearningStudioShowcaseComponent,
    SidenavLearningAnnexComponent,
    SidenavLearningUnitComponent,
    SidenavLearningStudioCategoryComponent,
    ModalCoursesComponent,
    ModalDuplicateCoursesComponent,
    ModalEventsComponent,
    ModalLearningFormElementComponent,
    AudioCardComponent,
    FlipCardComponent,
    ImageCardComponent,
    LinkCardComponent,
    TestCardComponent,
    VideoCardComponent,
    CardCourseComponent,
    FilterCoursePipe,
    ModalVoucherComponent,
    CollectionStudioComponent,
    PreviewCertificadoComponent,
    ModalCertificateComponent,
    ModalCertificateFormComponent,
    ModalCertificatePreviewComponent,
    TreeSubdivisionComponent,
    TreeTrailComponent,
    PopoverSubdivisionsComponent,
    PopoverReportComponent,
    PopoverReportFilterComponent,
    ModalSubdivisionsComponent,
    ReportComponent,
    ModalReportComponent,
    ModalDocPreviewComponent,
    UploadAudioElementComponent,
    UploadFlipElementComponent,
    UploadImageElementComponent,
    UploadLinkElementComponent,
    UploadVideoElementComponent,
    ModalProductsVoucherComponent,
    OptionTreeSubdivisionComponent,
  ],
  exports: [
    CardCourseComponent,
    AudioCardComponent,
    FlipCardComponent,
    ImageCardComponent,
    LinkCardComponent,
    TestCardComponent,
    VideoCardComponent,
  ],
  imports: [
    BadgeComponent,
    LearningTrailsRoutingModule,
    SHARED_MODULES,
    PieChartModule,
    UserPhotoComponent,
    FormsModule,
    DragDropModule,
    TextEditorComponent,
    SharedManagerAssessmentsModule,
    UploadFileComponent,
    NgxDocViewerModule,
    FileViewerComponent,
    ModalDisplayChartComponent,
  ],
})
export class LearningTrailsModule {}
